import { requestCommissionUpdate } from "@faire/help-center-self-serve/brand/instantAnswers/orders-requestCommissionUpdate";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Truck } from "@faire/web/slate/icons/foundation/Truck";
import React from "react";
import { OTHER_NODES_LABEL } from "../../shared/other-node";
import { GeneralContactRetailerIA } from "../instantAnswers/shared-generalContactRetailer";
import { AddOrUpdate } from "../instantAnswers/shipping-addOrUpdate";
import { AddressAndPhoneNumber } from "../instantAnswers/shipping-addressAndPhoneNumber";
import { BrandResponsibility } from "../instantAnswers/shipping-brandResponsibility";
import { CarrierNotAvailable } from "../instantAnswers/shipping-carrierNotAvailable";
import { Customs } from "../instantAnswers/shipping-customs";
import { HowShippingWorks } from "../instantAnswers/shipping-howShippingWorks";
import { PackageDimensionsAndWeight } from "../instantAnswers/shipping-packageDimensionsAndWeight";
import { Reimbursement } from "../instantAnswers/shipping-reimbursement";
import { SwfAvailability } from "../instantAnswers/shipping-swfAvailability";
export var useShippingBrandNodes = function useShippingBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    Shipping: {
      id: "Shipping",
      label: strictLocalize({
        id: "65rufv",
        defaultMessage: [{
          "type": 0,
          "value": "Shipping"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Truck, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: ["Swf", "SOYO", "GeneralShippingIssues", "commissionChangeRequest", "OtherShippingL2"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "vrB+Tf",
        defaultMessage: [{
          "type": 0,
          "value": "Shipping issue"
        }]
      })
    },
    commissionChangeRequest: {
      id: "commissionChangeRequest",
      label: strictLocalize({
        id: "qhLY/+",
        defaultMessage: [{
          "type": 0,
          "value": "Request commission change"
        }]
      }),
      level: 2,
      instantAnswer: requestCommissionUpdate(strictLocalize, articles)
    },
    Swf: {
      id: "Swf",
      label: strictLocalize({
        id: "75iuUE",
        defaultMessage: [{
          "type": 0,
          "value": "Ship with Faire"
        }]
      }),
      children: ["Availability", "ShipmentTrackingSWF", "ShippingLabels", "InternationalOrdersSWF", "DamagedOrMissing", "Insurance", "CarrierPickup", "OtherSWF"],
      level: 2
    },
    SOYO: {
      id: "SOYO",
      label: strictLocalize({
        id: "p305Pd",
        defaultMessage: [{
          "type": 0,
          "value": "Ship on your own"
        }]
      }),
      children: ["ShipmentTrackingSOYO", "Reimbursement", "InternationalOrdersSOYO", "HowShippingWorks", "OtherSOYO"],
      level: 2
    },
    GeneralShippingIssues: {
      id: "GeneralShippingIssues",
      label: strictLocalize({
        id: "y+BsDB",
        defaultMessage: [{
          "type": 0,
          "value": "General shipping issues"
        }]
      }),
      children: ["HowShippingWorks"],
      level: 2
    },
    OtherShippingL2: {
      id: "OtherShippingL2",
      label: strictLocalize({
        id: "gTfp16",
        defaultMessage: [{
          "type": 0,
          "value": "Other"
        }]
      }),
      articles: [articles.FulfillingOrders.ACCEPTING_ORDER, articles.FulfillingOrders.FULFILLING_ORDER, articles.FulfillingOrders.SHIPPING_ORDER, articles.FulfillingOrders.SETTING_OUT_OF_STOCK],
      level: 2
    },
    Availability: {
      id: "Availability",
      label: strictLocalize({
        id: "q8F7FX",
        defaultMessage: [{
          "type": 0,
          "value": "Availability"
        }]
      }),
      children: ["SwfAvailability", "OtherBrandShippingSWFL4"],
      level: 3
    },
    ShipmentTrackingSWF: {
      id: "ShipmentTrackingSWF",
      label: strictLocalize({
        id: "wp2ESX",
        defaultMessage: [{
          "type": 0,
          "value": "Shipment tracking"
        }]
      }),
      children: ["CannotTrackShipment"],
      level: 3
    },
    ShippingLabels: {
      id: "ShippingLabels",
      label: strictLocalize({
        id: "XkQAUo",
        defaultMessage: [{
          "type": 0,
          "value": "Label issues"
        }]
      }),
      children: ["AddressAndPhoneNumber", "PackageDimensionsAndWeight", "CarrierNotAvailable"],
      level: 3
    },
    InternationalOrdersSWF: {
      id: "InternationalOrdersSWF",
      label: strictLocalize({
        id: "cr/lkA",
        defaultMessage: [{
          "type": 0,
          "value": "Issues with international shipping"
        }]
      }),
      children: ["BrandResponsibility", "Commercial", "Customs", "RefusedPackage", "ShippingUKandEU", "ShippingCAN", "ShippingUS", "OtherInternationalOrdersSWF"],
      level: 3
    },
    DamagedOrMissing: {
      id: "DamagedOrMissing",
      label: strictLocalize({
        id: "tEupbu",
        defaultMessage: [{
          "type": 0,
          "value": "Damaged or missing shipments"
        }]
      }),
      level: 3
    },
    Insurance: {
      id: "Insurance",
      label: strictLocalize({
        id: "fyTEwG",
        defaultMessage: [{
          "type": 0,
          "value": "Insurance with Ship with Faire"
        }]
      }),
      level: 3
    },
    CarrierPickup: {
      id: "CarrierPickup",
      label: strictLocalize({
        id: "Su4ID+",
        defaultMessage: [{
          "type": 0,
          "value": "Carrier pick-up"
        }]
      }),
      level: 3
    },
    OtherSWF: {
      id: "OtherSWF",
      label: OTHER_NODES_LABEL(strictLocalize),
      level: 3
    },
    ShipmentTrackingSOYO: {
      id: "ShipmentTrackingSOYO",
      label: strictLocalize({
        id: "wp2ESX",
        defaultMessage: [{
          "type": 0,
          "value": "Shipment tracking"
        }]
      }),
      children: ["AddOrUpdate", "OtherShipmentTrackingSOYO"],
      level: 3
    },
    Reimbursement: {
      id: "Reimbursement",
      label: strictLocalize({
        id: "DeO9j+",
        defaultMessage: [{
          "type": 0,
          "value": "Reimbursement of shipping costs"
        }]
      }),
      articles: [articles.FulfillingOrders.LABEL_ISSUES],
      instantAnswer: Reimbursement(strictLocalize),
      level: 3
    },
    InternationalOrdersSOYO: {
      id: "InternationalOrdersSOYO",
      label: strictLocalize({
        id: "cr/lkA",
        defaultMessage: [{
          "type": 0,
          "value": "Issues with international shipping"
        }]
      }),
      children: ["BrandResponsibility", "Commercial", "Customs", "RefusedPackage", "ShippingUKandEU", "ShippingCAN", "ShippingUS", "OtherInternationalOrdersSOYO"],
      level: 3
    },
    HowShippingWorks: {
      id: "HowShippingWorks",
      label: strictLocalize({
        id: "QWS/Kc",
        defaultMessage: [{
          "type": 0,
          "value": "How does shipping work"
        }]
      }),
      instantAnswer: HowShippingWorks(strictLocalize),
      articles: [articles.FulfillingOrders.SHIPPING_ORDER, articles.International.SELLING],
      level: 3
    },
    OtherSOYO: {
      id: "OtherSOYO",
      label: OTHER_NODES_LABEL(strictLocalize),
      level: 3
    },
    SwfAvailability: {
      id: "SwfAvailability",
      label: strictLocalize({
        id: "IUwO+i",
        defaultMessage: [{
          "type": 0,
          "value": "Is Ship with Faire available in my country"
        }]
      }),
      instantAnswer: SwfAvailability(strictLocalize),
      articles: [articles.FulfillingOrders.SHIP_WITH_FAIRE],
      level: 4
    },
    CannotTrackShipment: {
      id: "CannotTrackShipment",
      label: strictLocalize({
        id: "scg8d5",
        defaultMessage: [{
          "type": 0,
          "value": "Cannot track shipment using SWF label"
        }]
      }),
      level: 4
    },
    AddressAndPhoneNumber: {
      id: "AddressAndPhoneNumber",
      label: strictLocalize({
        id: "fSg6za",
        defaultMessage: [{
          "type": 0,
          "value": "Address and phone number"
        }]
      }),
      instantAnswer: AddressAndPhoneNumber(strictLocalize),
      articles: [articles.FulfillingOrders.LABEL_ISSUES],
      level: 4
    },
    PackageDimensionsAndWeight: {
      id: "PackageDimensionsAndWeight",
      label: strictLocalize({
        id: "BrGStH",
        defaultMessage: [{
          "type": 0,
          "value": "Package dimensions and weight"
        }]
      }),
      instantAnswer: PackageDimensionsAndWeight(strictLocalize),
      articles: [articles.FulfillingOrders.LABEL_ISSUES],
      level: 4
    },
    CarrierNotAvailable: {
      id: "CarrierNotAvailable",
      label: strictLocalize({
        id: "2h4UiZ",
        defaultMessage: [{
          "type": 0,
          "value": "Carrier not available"
        }]
      }),
      instantAnswer: CarrierNotAvailable(strictLocalize),
      articles: [articles.FulfillingOrders.LABEL_ISSUES],
      level: 4
    },
    BrandResponsibility: {
      id: "BrandResponsibility",
      label: strictLocalize({
        id: "1vHsRW",
        defaultMessage: [{
          "type": 0,
          "value": "Brand’s responsibility"
        }]
      }),
      instantAnswer: BrandResponsibility(strictLocalize),
      level: 4
    },
    Commercial: {
      id: "Commercial",
      label: strictLocalize({
        id: "as7tT+",
        defaultMessage: [{
          "type": 0,
          "value": "Commercial invoices and documentation"
        }]
      }),
      articles: [articles.FulfillingOrders.COMMERCIAL_INVOICE],
      level: 4
    },
    Customs: {
      id: "Customs",
      label: strictLocalize({
        id: "OJUcir",
        defaultMessage: [{
          "type": 0,
          "value": "Contact the retailer about customs"
        }]
      }),
      instantAnswer: Customs(strictLocalize),
      level: 4
    },
    RefusedPackage: {
      id: "RefusedPackage",
      label: strictLocalize({
        id: "aeIY3c",
        defaultMessage: [{
          "type": 0,
          "value": "Retailer refused package at customs"
        }]
      }),
      instantAnswer: GeneralContactRetailerIA(strictLocalize),
      level: 4
    },
    ShippingUKandEU: {
      id: "ShippingUKandEU",
      label: strictLocalize({
        id: "Fhs4qX",
        defaultMessage: [{
          "type": 0,
          "value": "Shipping into UK and EU"
        }]
      }),
      level: 4
    },
    ShippingCAN: {
      id: "ShippingCAN",
      label: strictLocalize({
        id: "KEKi3e",
        defaultMessage: [{
          "type": 0,
          "value": "Shipping into Canada"
        }]
      }),
      level: 4
    },
    ShippingUS: {
      id: "ShippingUS",
      label: strictLocalize({
        id: "DhQpL+",
        defaultMessage: [{
          "type": 0,
          "value": "Shipping into US"
        }]
      }),
      level: 4
    },
    OtherInternationalOrdersSOYO: {
      id: "OtherInternationalOrdersSOYO",
      label: OTHER_NODES_LABEL(strictLocalize),
      level: 4
    },
    OtherInternationalOrdersSWF: {
      id: "OtherInternationalOrdersSWF",
      label: OTHER_NODES_LABEL(strictLocalize),
      level: 4
    },
    AddOrUpdate: {
      id: "AddOrUpdate",
      label: strictLocalize({
        id: "RS34ZR",
        defaultMessage: [{
          "type": 0,
          "value": "Add/Update"
        }]
      }),
      instantAnswer: AddOrUpdate(strictLocalize),
      articles: [articles.FulfillingOrders.SHIP_ON_YOUR_OWN, articles.FulfillingOrders.EDIT_RETAILER_ORDER],
      level: 4
    },
    OtherShipmentTrackingSOYO: {
      id: "OtherShipmentTrackingSOYO",
      label: OTHER_NODES_LABEL(strictLocalize),
      level: 4
    },
    OtherBrandShippingSWFL4: {
      id: "OtherBrandShippingSWFL4",
      label: strictLocalize({
        id: "ISA75e",
        defaultMessage: [{
          "type": 0,
          "value": "Other"
        }]
      }),
      articles: [articles.FulfillingOrders.SHIP_WITH_FAIRE],
      level: 4
    }
  };
};